import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  HuseierneMembershipStatusState,
  UpdateHuseierneMembershipStatusRequest,
} from "./interfaces";

const updateHuseierneMembershipStatusSlice = createSlice({
  name: "updateHuseierneMembershipStatus",
  initialState: {} as HuseierneMembershipStatusState,
  reducers: {
    updateHuseierneMembershipStatusStart: (
      state: HuseierneMembershipStatusState,
      action: PayloadAction<UpdateHuseierneMembershipStatusRequest>,
    ) => {
      const {
        payload: { huseierneMembershipStatus },
      } = action;
      state.huseierneMembershipStatus = huseierneMembershipStatus;
      state.isLoading = true;
      state.error = undefined;
    },
    updateHuseierneMembershipStatusSucceded: (
      state: HuseierneMembershipStatusState,
    ) => {
      state.isLoading = false;
      state.error = false;
    },
    updateHuseierneMembershipStatusError: (
      state: HuseierneMembershipStatusState,
    ) => {
      state.isLoading = false;
      state.error = true;
    },
  },
});

export const {
  updateHuseierneMembershipStatusStart,
  updateHuseierneMembershipStatusSucceded,
  updateHuseierneMembershipStatusError,
} = updateHuseierneMembershipStatusSlice.actions;
export const updateHuseierneMembershipStatus =
  updateHuseierneMembershipStatusSlice.reducer;
